import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { EmergingAlternative } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface EmergingAlternativesProps {
    data?: EmergingAlternative[];
    style?: CSSProperties;
}

export const EmergingAlternatives: FC<EmergingAlternativesProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                New entrants and alternative solutions
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Emerging Alternatives" dataIndex="alternative" width={334} />
                <Column title="Pricing and Innovation Benefits" dataIndex="benefits" width={334} />
                <Column title="Market Traction" dataIndex="market" />
            </Table>
        </div>
    );
};
